import { DialogProps } from "@mui/material";
import DialogFullScreen from "../DialogFullScreen";


export default function DialogListarTodas({
    open,
    title,
    children,
    handleClose
}: DialogListarTodasProps) {

    return (
        <DialogFullScreen
            {...{ open, handleClose }}
            title={title}
        >
            {children}
        </DialogFullScreen>
    )
}

interface DialogListarTodasProps extends DialogProps {
    title: string,
    open: boolean,
    children: React.ReactNode,
    handleClose: () => void,
}